import { Component, Input, OnInit } from '@angular/core';
import { PermissionEnum } from '@app/core/services/administrator/models/enum/permission.enum';
import { PaymentType } from '@app/core/services/transaction/model/enum/payment-type.enum';
import { OrderItem } from '@app/core/services/transaction/model/order-item.model';
import { Order } from '@app/core/services/transaction/model/order.model';
import { Transaction } from '@app/core/services/transaction/model/transaction.model';
import { OrderItemDetailsDialogComponent } from '../../order-item-details-dialog/order-item-details-dialog.component';
import { MatDialog } from '@angular/material/dialog';
import { Router } from '@angular/router';
import { UtilService } from '@app/core/services/util/util.service';

@Component({
  selector: 'ap-transaction-details-orders',
  templateUrl: './transaction-details-orders.component.html',
  styleUrl: './transaction-details-orders.component.css',
  standalone: false
})
export class TransactionDetailsOrdersComponent implements OnInit {

  @Input() order: Order;
  @Input() transaction: Transaction;
  @Input() userView = false;

  Permissions = PermissionEnum;
  PaymentType = PaymentType;

  orderItemColumns = ['LABEL', 'SERVICE_PROVIDER', 'QUANTITY', 'UNITARY_AMOUNT_EXCL_TAX', 'TAX', 'UNITARY_AMOUNT', 'TOTAL_AMOUNT_EXCL_TAX', 'TOTAL_AMOUNT', 'REFUND_STATE', 'ACTIONS']
  footerOrderItemColumns = ['LABEL', 'TOTAL_AMOUNT_EXCL_TAX', 'TOTAL_AMOUNT', 'REFUND_STATE', 'ACTIONS'];

  constructor(private dialog: MatDialog, private router: Router, private utilService: UtilService) {}

  ngOnInit(): void {
    if (this.order?.orderItems && this.order.orderItems.length > 0) {
      this.order.orderItems = this.order.orderItems.sort((a,b) => this.utilService.compare(a.orderItemId, b.orderItemId, true));
    }
  }

  navigateToUser(mobilityAccountId: number) {
    this.router.navigate(['/users', mobilityAccountId, 'all']);
  }

  showOrderItemDetails(orderItem: OrderItem) {
    this.dialog.open(OrderItemDetailsDialogComponent, {
      panelClass: 'modal',
      width: '60%',
      data: {
        orderItem: orderItem
      }
    });
  }
}
